module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_03.5d6ab9b5.png";